import { useState, useEffect, useRef } from 'react'
import { getAllDepartamentosV2 } from '../../../Services/departamentoService'
import Swal from 'sweetalert2'

const usePagination = (history, isActive = true) => {
    let token = JSON.parse(atob(sessionStorage.getItem('token').split('.')[1]))
    let rol = token.authorities[0]
    const [isLoad, setIsLoad] = useState(true)
    const [departamentos, setDepartamentos] = useState([])

    //Pagination
    const [page, setPage] = useState(0)
    const [totalRegister, setTotalRegister] = useState(0)
    const [totalPage, setTotalPage] = useState(0)
    const [query, setQuery] = useState('')
    const lastSearchRef = useRef('')

    useEffect(() => {
        if (rol !== 'ROLE_ADMIN') history.goBack()
        if (isLoad) {
            getAllDepartamentosV2(isActive, 0, query)
                .then((res) => {
                    setDepartamentos(res.data.content)
                    setTotalRegister(res.data.totalElements)
                    setTotalPage(res.data.totalPages)
                    setIsLoad(false)
                })
                .catch((error) => console.log(error.response))
        } else {
            setIsLoad(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoad])

    const nextPage = () => {
        if (totalPage === 0) {
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'No hay mas páginas',
                type: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
            return
        }
        if (page === totalPage - 1) {
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'No hay mas páginas',
                type: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
            return
        }
        getAllDepartamentosV2(isActive, page + 1)
            .then((res) => {
                setPage(page + 1)
                setDepartamentos(res.data.content)
                setTotalRegister(res.data.totalElements)
                setTotalPage(res.data.totalPages)
                setIsLoad(false)
            })
            .catch((err) => console.log('error'))
    }

    const previousPage = () => {
        if (page === 0) {
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'No hay mas páginas',
                type: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
            return
        }
        getAllDepartamentosV2(isActive, page - 1)
            .then((res) => {
                setPage(page - 1)
                setDepartamentos(res.data.content)
                setTotalRegister(res.data.totalElements)
                setTotalPage(res.data.totalPages)
                setIsLoad(false)
            })
            .catch((err) => console.log('error'))
    }

    const handleBuscador = (e) => {
        setQuery(e.target.value)
        if (e.key === 'Enter') {
            const trimmedValue = e.target.value.trim()
            // Si el input está vacío y había una búsqueda previa, se resetean todos los datos
            if (trimmedValue === '' && lastSearchRef.current !== '') {
                getAllDepartamentosV2(isActive, 0, e.target.value)
                    .then((res) => {
                        setPage(0)
                        setDepartamentos(res.data.content)
                        setTotalRegister(res.data.totalElements)
                        setTotalPage(res.data.totalPages)
                        setIsLoad(false)
                        lastSearchRef.current = '' // Se actualiza la referencia al estado vacío
                    })
                    .catch((err) => console.log('error'))
            }
            // Si hay contenido y es diferente a la última búsqueda, hace una nueva búsqueda
            else if (trimmedValue !== '' && trimmedValue !== lastSearchRef.current) {
                getAllDepartamentosV2(isActive, 0, e.target.value)
                    .then((res) => {
                        setPage(0)
                        setDepartamentos(res.data.content)
                        setTotalRegister(res.data.totalElements)
                        setTotalPage(res.data.totalPages)
                        setIsLoad(false)
                        lastSearchRef.current = trimmedValue //Actualizo la referencia a la busqueda actual
                    })
                    .catch((err) => console.log('error'))
            }
        }
    }

    return {
        page,
        totalRegister,
        totalPage,
        setIsLoad,
        departamentos,
        nextPage,
        previousPage,
        handleBuscador,
    }
}

export default usePagination
